import { render, staticRenderFns } from "./CampoDeTelefone.vue?vue&type=template&id=3ac9cd5e&"
import script from "./CampoDeTelefone.vue?vue&type=script&lang=ts&"
export * from "./CampoDeTelefone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
